import types from 'redux/types';

const getListDialog = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_LIST_DIALOG,
  };
};

const getListDialogTemplate = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_LIST_DIALOG_TEMPLATE,
  };
};

const loadMoreDialog = (data) => {
  return {
    ...data,
    type: types.REQUEST_LOAD_MORE_RESPONDER,
  };
};

const filterDialog = (data) => {
  return {
    ...data,
    type: types.REQUEST_FILTER_RESPONDER,
  };
};

const getDetailDialog = (data) => {
  return {
    type: types.REQUEST_GET_RESPONDER_DETAIL,
    ...data,
  };
};

const clearDetailDialog = () => {
  return {
    type: types.CLEAR_RESPONDER_DETAIL,
  };
};

const switchStatusResponder = (data) => {
  return {
    type: types.REQUEST_SWITCH_RESPONDER,
    ...data,
  };
};

const deleteResponder = (data) => {
  return {
    type: types.REQUEST_DELETE_RESPONDER,
    ...data,
  };
};

const addResponder = (data) => {
  return {
    type: types.REQUEST_ADD_RESPONDER,
    ...data,
  };
};

const uploadNodes = (data) => {
  return {
    type: types.REQUEST_UPLOAD_NODE,
    ...data,
  };
};

const saveDialogContent = (data) => {
  return {
    type: types.REQUEST_SAVE_RESPONDER_CONTENT,
    ...data,
  };
};

const updateDialog = (data) => {
  return {
    type: types.REQUEST_SAVE_DIALOG,
    ...data,
  };
};

const deleteDialogContent = (data) => {
  return {
    type: types.REQUEST_DELETE_RESPONDER_CONTENT,
    ...data,
  };
};

const selectNode = (data) => {
  return {
    type: types.REQUEST_SELECTED_NODE,
    ...data,
  };
};

const clearNode = () => {
  return {
    type: types.CLEAR_SELECTED_NODE,
  };
};

const setDidGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_SET_DID_GROUP_RESPONDER,
  };
};

export default {
  filterDialog,
  loadMoreDialog,
  setDidGroup,
  getListDialogTemplate,
  deleteDialogContent,
  selectNode,
  clearNode,
  uploadNodes,
  saveDialogContent,
  updateDialog,
  getDetailDialog,
  clearDetailDialog,
  addResponder,
  deleteResponder,
  getListDialog,
  switchStatusResponder,
};
